const vehicle = [
    {
        license_number : 'BK 2021 YR',
        vehicle_name : 'Avanza',
        type : 'Car',
        condition : 'Good',
        year_bought : '2021',
        total_km : '1560',
        last_maintenance : '12-11-2024',
        
    },
    {
        license_number : 'BK 4568 KZ',
        vehicle_name : 'Inova',
        type : 'Car',
        condition : 'Good',
        year_bought : '2019',
        total_km : '2365',
        last_maintenance : '12-11-2024',
        
    },
    {
        license_number : 'BK 7855 SL',
        vehicle_name : 'Hiace',
        type : 'Bus',
        condition : 'need service',
        year_bought : '2019',
        total_km : '2365',
        last_maintenance : '12-11-2024',
        
    },
    {
        license_number : 'BK 7888 AP',
        vehicle_name : 'Fortuner',
        type : 'Car',
        condition : 'On Service',
        year_bought : '2020',
        total_km : '2569',
        last_maintenance : '12-11-2024',
        
    },
    {
        license_number : 'BK 4582 SK',
        vehicle_name : 'Inova',
        type : 'Car',
        condition : 'Good',
        year_bought : '2018',
        total_km : '3556',
        last_maintenance : '12-11-2024',
        
    },
    
    
]

export default vehicle